export default class LoginCtrl{
  constructor(AuthService){
    this.AuthService = AuthService;
    this.login = "";
    this.password = "";
    this.error = false;
    // try to log me in first ....
    AuthService.autologin();
  }

  submit(){
    this.AuthService.login(this.login, this.password).then(user =>{
      if(!user){
        this.password = "";
        this.error = true;
      }
    })
  }


}


// WEBPACK FOOTER //
// ./src/auth/LoginCtrl.js